module.exports = __webpack_public_path__ + "static/img/end_03.40a0a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/end_03.jpg
// module id = Trxy
// module chunks = 3